import axios from 'axios';
import { useState, useEffect } from 'react';
import { changeSaleStatusData } from '../../common/utils';
import hubIcon1 from '../../../img/hubIcon1.png';
import hubIcon2 from '../../../img/hubIcon2.png';
import hubIcon3 from '../../../img/hubIcon3.png';

function HubCount(props) {
	const [HubCountData, setHubCountData] = useState([]);
	const [IsDisable, setIsDisable] = useState(false);
	const hubIcons = [hubIcon1, hubIcon2, hubIcon3];
	const qs = require('qs');
	const onSearch = (value) => {
		const newParams = {
			commodityCode: '',
			name: '',
			dt: {
				periodType: null,
				before: '',
				after: '',
			},
			model: '',
			manufacturer: '',
			brand: '',
			status: [value],
			// category: {
			// 	category1: '',
			// 	category2: '',
			// 	category3: '',
			// 	category4: '',
			// },
			vendorCode: [],
		};
		// onSearch함수가 실행될 때마다 실행
		if (!IsDisable) {
			props.getCountParams(newParams);
		} else {
			alert('잠시 후 다시 요청해주세요.');
		}
	};
	useEffect(() => {
		axios
			.post(
				`${window.location.protocol}//${window.location.hostname}:3001/getProductCount`,
				qs.stringify({
					token: localStorage.getItem('token'),
				})
			)
			.then((res) => {
				const newArr = Object.entries(res.data)?.map((m) => {
					return {
						text: m[0],
						count: m[1],
					};
				});
				setHubCountData(newArr);
			})
			.catch();
	}, []);
	useEffect(() => {
		const newIs = props.isLoading;
		if (newIs) {
			//재검색이 이뤄질 때마다 count값 다시 받아오기
			axios
				.post(
					`${window.location.protocol}//${window.location.hostname}:3001/getProductCount`,
					qs.stringify({
						token: localStorage.getItem('token'),
					})
				)
				.then((res) => {
					const newArr = Object.entries(res.data)?.map((m) => {
						return {
							text: m[0],
							count: m[1],
						};
					});
					setHubCountData(newArr);
				})
				.catch();
		}
		setIsDisable(newIs);
	}, [props.isLoading]);
	return (
		<div className='countBox'>
			<ul>
				{HubCountData?.map((el, index) => (
					<li key={index} onClick={() => onSearch(el.text)}>
						<span className='countIcon'>
							<img src={hubIcons[index]} alt='hubIcon' />
						</span>
						<span className='countText'>
							<span>{changeSaleStatusData(el.text)}</span>
							<span>
								<strong>{el.count}</strong>건
							</span>
						</span>
					</li>
				))}
			</ul>
		</div>
	);
}

export default HubCount;
